import { ref, onMounted, onBeforeUnmount } from 'vue';

export const useWindowResize = () => {
	const width = ref(window.innerWidth);
	const height = ref(window.innerHeight);

	const handler = () => {
		width.value = window.innerWidth;
		height.value = window.innerHeight;
	};

	onMounted(() => window.addEventListener('resize', handler));
	onBeforeUnmount(() => window.removeEventListener('resize', handler));

	return { width, height };
}
